import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Container from "../components/container"
import styled from "@emotion/styled"
import {
  Heading, 
  Text, 
  Box, 
  Divider,
} from "@chakra-ui/core";
// import theme from "../theme"

// import INLINES from '@contentful/rich-text-types/dist/lib/inlines';
import { BLOCKS, MARKS } from '@contentful/rich-text-types';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

const Styles = styled.div`
    // box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px;
    // grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
`

export default class extends React.Component {
  constructor ( props ) {
    super();
    this.state = {};
    this.state.node = props.pageContext.node
  }

  render() {

    let options = {
      renderMark: {
        [MARKS.BOLD]: text => <Text fontWeight="bold">{text}</Text>,
        [MARKS.ITALIC]: text => <Text fontStyle="italic">{text}</Text>,
        [MARKS.UNDERLINE]: text => <Text textDecoration="underline">{text}</Text>,

        // [INLINES.HYPERLINK]: (text) => <ChakraLink>{text}</ChakraLink>,
      },
      renderNode: {
        [BLOCKS.PARAGRAPH]: (node, children) => <Text mb={2}>{children}</Text>,
        [BLOCKS.HEADING_1]: (node, children) => <Heading>{children}</Heading>,
        [BLOCKS.HEADING_3]: (node, children) => <Heading size="md">{children}</Heading>,
        [BLOCKS.HEADING_6]: (node, children) => <Heading size="sm">{children}</Heading>,
        [BLOCKS.HR]: (node, children) => <Divider />,
      },
    }

    return (
      <Layout>
        <SEO title={ this.state.node.title } />

        <Styles>

            <Box bg="gray.100">
            <Container>
            <Heading  color={ "gray.900" } mb={6}>{ this.state.node.title }</Heading>

              <Text mb={2} >
                    { documentToReactComponents( this.state.node.body.json, options ) } 
                  </Text>
            </Container>
            </Box>
        </Styles>
      </Layout>
    )
  }
}

export const query = graphql`
  {
    trees: file(relativePath: {eq: "trees.png"}) {
      childImageSharp {
        fluid(maxWidth: 540) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`